import React, {useEffect, useRef, useState} from "react";
import HeatSelector from "../shared/HeatSelector";
import { apiClient } from '@iziping/common';
import type {HeatBracket} from '@iziping/common';
import { ENDPOINTS } from '@/model/endpoints';
import HeatBracketDisplay from "./HeatBracketDisplay";
import {useTranslation} from "react-i18next";
import {useReactToPrint} from "react-to-print";
import {Printer} from "lucide-react";


const BracketVisualizationPage: React.FC = () => {
    const [selectedHeat, setSelectedHeat] = useState<number | undefined>(undefined);
    const [matches, setMatches] = useState<HeatBracket | null>(null);
    const [loading, setLoading] = useState(false);
    const {t} = useTranslation();

    // Fonction de callback qui sera appelée lorsque l'utilisateur sélectionne une série
    const handleHeatSelect = (id: number) => {
        setSelectedHeat(id); // Mise à jour de l'ID de la série sélectionnée
    };

    const fetchMatches = async (heatId: number) => {
        setLoading(true);
        try {
            const response = await apiClient.get<HeatBracket>(`${ENDPOINTS.getFinalBracketForHeat(heatId)}`);
            setMatches(response.data);
        } catch (error) {
            console.error("Erreur lors du chargement des matchs:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        // Si selectedHeat change, il peut déclencher une requête ou un calcul
        if (selectedHeat !== undefined) {
            fetchMatches(selectedHeat!);
        }
    }, [selectedHeat]);

    const bracketRef = useRef<HTMLDivElement>(null);

    const handlePrint = useReactToPrint({
        contentRef: bracketRef,
        documentTitle: `heat-bracket-${selectedHeat}`,
    });

    return (
        <>
            <div className="page">
                <HeatSelector onSelect={handleHeatSelect}/>
                <button className={'button'} onClick={handlePrint}>
                    <Printer size={20}/>
                </button>
            </div>
            {loading ? (
                <p>{t('LOADING_HEAT_BRACKET')}</p>
            ) : (
                <div ref={bracketRef}>
                    <HeatBracketDisplay bracket={matches!}/>
                </div>
            )}
        </>

    )
}

export default BracketVisualizationPage;